<template>
  <div id="confirm-registration-form">
    <Form
      :header="header"
      :model="model"
      :schema="schema"
      :options="options"
      :buttons="buttons"
      :messages="messages"
      @form_submit="form_submit"
    ></Form>
  </div>
</template>

<script>
import Vue from "vue";
import Form from "../../components/Form";
import VueFormGenerator from "vue-form-generator";
import { get_validator_messages } from "../../validators/locale_pl";

var validator_messages = get_validator_messages();

export default {
  name: "ConfirmRegistration",
  components: {
    Form
  },
  data() {
    return {
      buttons: [
        {
          name: "confirm",
          style_classes: "float-right mb-1",
          buttons: [
            {
              label: "Zweryfikuj",
              variant: "success",
              type: "submit",
              name: "confirm",
              icon: "shield-lock-fill"
            }
          ]
        }
      ],
      header: {
        title: "Weryfikacja adresu email.",
        icon: "shield-lock-fill"
      },
      model: {
        email: null,
        code: null
      },
      messages: [
        {
          variant: "success",
          label: "Rejestracja przebiegła pomyślnie."
        },
        {
          variant: "primary",
          label:
            "Wysłaliśmy do Ciebie wiadomość z kodem weryfikacyjnym. Wprowadź kod aby zweryfikować adres email."
        }
      ],
      options: {
        validateAfterChanged: true,
        validateAsync: true
      },
      schema: {
        groups: [
          {
            styleClasses: "form-row",
            fields: [
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "email",
                label: "Email",
                model: "email",
                required: true,
                validator: [
                  VueFormGenerator.validators.email.locale(validator_messages)
                ]
              },
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "text",
                label: "Kod",
                model: "code",
                required: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              }
            ]
          }
        ]
      }
    };
  },
  mounted() {
    this.$nextTick(function() {
      console.log(
        "Regsiter success:",
        this.$localStorage.get("register_success")
      );
      this.model.email = this.$localStorage.get("register_success");
    });
  },
  methods: {
    form_submit: function(model) {
      console.log(model);
      Vue.CognitoAuth.confirm_registration(
        model.email,
        model.code,
        this.confirmation_success,
        this.confirmation_failure
      );
    },
    confirmation_success: function() {
      this.messages = [];
      this.$router.push({ name: "Login" });
    },
    confirmation_failure: function(err) {
      console.log("Error:", err);
      this.messages = [];
      this.messages = [
        {
          label: err,
          variant: "danger"
        }
      ];
    }
  }
};
</script>

<style>
@media (min-width: 768px) {
  #confirm-registration-form .form-container {
    max-width: 520px;
  }
}
</style>
